module.exports = __webpack_public_path__ + "static/media/orcamento-2.a2f1a81f.png";